import { PrimaryButton } from '@systemeio/ui'
import { useGetNewsletterView } from 'modules/newsletters/single/hooks/use-get-newsletter-view'
import { NewsletterId } from 'modules/newsletters/single/types/newsletter-interface'
import { useCreateSplitTest } from 'modules/newsletters/split-test/hooks/use-create-split-test'
import React, { useState } from 'react'
import ConfirmationModal from 'shared/components/confirmation-modal'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { SplitTestIcon } from '@systemeio/ui/icons'

interface DuplicateNewsletterModalProps {
  newsletterId: NewsletterId
  isDisabled: boolean
}

export const CreateSplitTestModal = ({
  newsletterId,
  isDisabled,
}: DuplicateNewsletterModalProps) => {
  const { t } = useLocoTranslation()
  const [isOpened, setIsOpened] = useState<boolean>(false)
  const { createSplitTest } = useCreateSplitTest()

  const { mutateNewslettersData } = useGetNewsletterView({
    newsletterId,
  })

  const handleConfirm = async () => {
    try {
      const response = await createSplitTest(newsletterId)
      await mutateNewslettersData(data => data && { ...data, mailingSplitTest: response })
    } catch (e) {
      throw e
    }
  }

  return (
    <React.Fragment>
      <PrimaryButton onClick={() => setIsOpened(true)} disabled={isDisabled}>
        <SplitTestIcon className={'fill-background-secondary h-[20px] w-[20px]'} />
        <span className="hidden lg:flex">
          {t('dashboard.newsletter_editor.split_test.create_title')}
        </span>
      </PrimaryButton>
      <ConfirmationModal
        confirmationText={t('dashboard.newsletter_editor.split_test.create_description')}
        opened={isOpened}
        onClose={() => setIsOpened(false)}
        onConfirm={async () => {
          await handleConfirm()
        }}
      />
    </React.Fragment>
  )
}
